import { grayPalette } from '../../../themes/colors';

export const titleDarkTheme = {
  styles: {
    fontFamily: 'Ubuntu, sans-serif',
  },
  fontWeight: 700,
  color: grayPalette[100],
};
